<template>
    <div id="our-offer">
        <div class="container intro">
            <div>
                <div v-if="!isMobile" class="desktop">
                    <img src="@/assets/img/home/mission_fr.webp" alt="" v-if="local == 'fr'" width="1920" height="1080" />
                    <img src="@/assets/img/home/mission_en.webp" alt="" v-if="local == 'en'" width="1920" height="1080" />

                    <div v-for="(zone, idx) in zonesOffers" :class="'zone zone-' + idx" @mouseover="displayMsg(idx)" @mouseleave="displayMsg(false)" :key="idx" :style="{ width: zone.pos['lg'].width + '%', height: zone.pos['lg'].height + '%', top: zone.pos['lg'].top + '%', left: zone.pos['lg'].left + '%' }">
                        <Transition>
                            <div class="msg" v-if="zones[idx]">{{ zone.content[this.local] }}</div>
                        </Transition>
                    </div>
                </div>

                <div v-if="isMobile" class="mobile">
                    <img src="@/assets/img/home/mission_mobile_fr.webp" alt="" v-if="local == 'fr'" width="1080" height="1551" />
                    <img src="@/assets/img/home/mission_mobile_en.webp" alt="" v-if="local == 'en'" width="1080" height="1551" />

                    <Transition v-for="(zone, idx) in zonesOffers">
                        <div class="msg" v-if="zones[idx]">{{ zone.content[this.local] }}</div>
                    </Transition>

                    <div v-for="(zone, idx) in zonesOffers" :class="'zone zone-' + idx" @mouseover="displayMsg(idx)" @mouseleave="displayMsg(false)" :key="idx" :style="{ width: zone.pos['sm'].width + '%', height: zone.pos['sm'].height + '%', top: zone.pos['sm'].top + '%', left: zone.pos['sm'].left + '%' }">
                        <div class="led-yellow led" :class="'led-' + idx" v-if="[0, 3, 6, 9, 12, 15].indexOf(idx) != -1"></div>
                        <div class="led-red led" :class="'led-' + idx" v-if="[1, 4, 7, 10, 13, 16].indexOf(idx) != -1"></div>
                        <div class="led-blue led" :class="'led-' + idx" v-if="[2, 5, 8, 11, 14].indexOf(idx) != -1"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="our-offer" ref="our-offer">
            <div v-html="$t('message.title_our_offer')" class="main-title"></div>
            <div>
                <a href="agence">
                    <div>
                        <div class="title">
                            <span>{{ $t("message.title_our_offer_1") }}</span>
                        </div>
                        <div class="desc">
                            <span v-html="$t('message.desc_our_offer_1')"></span>
                        </div>
                        <div class="media">
                            <img src="@/assets/img/home/Offre_1.webp" alt="" width="960" height="540" />
                        </div>
                        <span class="btn">
                            {{ $t("message.btn_our_offer_1") }}
                        </span>
                    </div>
                </a>
                <a href="references">
                    <div>
                        <div class="title">
                            <span>{{ $t("message.title_our_offer_2") }}</span>
                        </div>
                        <div class="desc">
                            <span v-html="$t('message.desc_our_offer_2')"></span>
                        </div>
                        <div class="media">
                            <img src="@/assets/img/home/Offre_2.webp" alt="" width="960" height="540" />
                        </div>
                        <span class="btn">
                            {{ $t("message.btn_our_offer_2") }}
                        </span>
                    </div>
                </a>
                <a href="formavisa">
                    <div>
                        <div class="title">
                            <span>{{ $t("message.title_our_offer_6") }}</span>
                        </div>
                        <div class="desc">
                            <span v-html="$t('message.desc_our_offer_6')"></span>
                        </div>
                        <div class="media">
                            <img src="@/assets/img/home/Offre_6.webp" alt="" width="960" height="540" />
                        </div>
                        <span class="btn">
                            {{ $t("message.btn_our_offer_6") }}
                        </span>
                    </div>
                </a>
                <!--<div @click="runFilter(local == 'fr' ? 'Vidéo' : 'Video')">-->
                <div>
                    <div>
                        <div class="title">
                            <span>{{ $t("message.title_our_offer_4") }}</span>
                        </div>
                        <div class="desc">
                            <span v-html="$t('message.desc_our_offer_4')"></span>
                        </div>
                        <div class="media">
                            <img src="@/assets/img/home/Offre_4.webp" alt="" width="960" height="540" />
                        </div>
                        <!--<span class="btn">
                            {{ $t("message.btn_our_offer_4") }}
                        </span>-->
                    </div>
                </div>
                <!--<a href="technos">-->
                <div>
                    <div>
                        <div class="title">
                            <span>{{ $t("message.title_our_offer_5") }}</span>
                        </div>
                        <div class="desc">
                            <span v-html="$t('message.desc_our_offer_5')"></span>
                        </div>
                        <div class="media">
                            <img src="@/assets/img/home/Offre_5.webp" alt="" width="960" height="540" />
                        </div>
                        <!--<span class="btn">
                            {{ $t("message.btn_our_offer_5") }}
                        </span>-->
                    </div>
                </div>
                <!--<a href="lab">-->
                <div>
                    <div>
                        <div class="title">
                            <span>{{ $t("message.title_our_offer_3") }}</span>
                        </div>
                        <div class="desc">
                            <span v-html="$t('message.desc_our_offer_3')"></span>
                        </div>
                        <div class="media">
                            <img src="@/assets/img/home/Offre_3.webp" alt="" width="960" height="540" />
                        </div>
                        <!--<span class="btn">
                            {{ $t("message.btn_our_offer_3") }}
                        </span>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Focus from "./img/Focus.vue";
import HotTrend from "./img/HotTrend.vue";
import Lab from "./img/Lab.vue";
import Play from "./img/Play.vue";

export default {
    name: "OurOffer",
    data() {
        return {
            local: "fr",
            indexRef: 0,
            isMobile: false,
            zonesOffers: null,
            zones: [],
        };
    },
    components: {
        Focus,
        HotTrend,
        Lab,
        Play,
    },
    created() {
        for (let i = 0; i < this.$store.state.app.zones_offers.length; i++) this.zones.push(false);
    },
    mounted() {
        let _this = this;
        this.local = this.$i18n.locale;

        /**
         * Ajout class si version mobile
         */
        window.addEventListener("resize", function (e) {
            _this.isItMobile();
        });
        this.isItMobile();
        this.zonesOffers = this.$store.state.app.zones_offers;
    },
    watch: {
        "$i18n.locale": function (locale) {
            this.local = locale;
        },
    },
    methods: {
        displayFocusProject(idx) {
            this.$store.dispatch("app/setResetVideoHome", true);

            this.$store.dispatch("app/displayModal", {
                display: true,
                name: "reference",
                content: this.$store.getters["app/getRef"](this.local, idx),
            });
        },
        displayMsg(index) {
            for (let i = 0; i < this.zones.length; i++) {
                this.zones[i] = false;
                if (i === this.zones.length - 1 && index !== false) this.zones[index] = true;
            }
        },
        displayGame(index) {
            this.$store.dispatch("app/displayModal", {
                display: true,
                name: "game",
                content: this.$store.state.app.games[this.local][index],
            });
        },
        runFilter(tag) {
            this.$store.dispatch("app/setFilter", "");

            for (let i = 0; i < this.$store.state.app.filters[this.local].length; i++) {
                let filterMetier = this.$store.state.app.filters[this.local][i];
                if (tag === filterMetier) this.$store.dispatch("app/setFilter", tag);
            }

            localStorage.setItem("tags", JSON.stringify([tag]));
            const url = `./references`;
            window.location.href = url;

            this.$store.dispatch("app/displayModal", {
                display: false,
            });
        },
        isItMobile() {
            let windowWidth = window.innerWidth;
            if (windowWidth < 992) {
                this.isMobile = true;
            } else {
                this.isMobile = false;
            }
        },
    },
};
</script>

<style scoped lang="scss">
#our-offer {
    position: relative;
}

.intro {
    text-align: center;
    margin: 4rem 0;

    > div {
        border-radius: 23px;
        box-sizing: border-box;
        position: relative;
        overflow: hidden;
        width: 100%;
        max-width: 1400px;
        margin: auto;

        > div {
            cursor: url(@/assets/img/pointer_01.png), pointer;

            img {
                width: 100%;
                height: auto;
                display: block;
            }
        }
    }

    .desktop {
        .zone {
            position: absolute;
            //border: 1px solid red;

            .msg {
                background-color: rgba(255, 0, 0, 0.9);
                color: #fff;
                border-radius: 15px;
                overflow: hidden;
                width: 300px;
                padding: 1rem;
                box-sizing: border-box;
                font-size: 0.9rem;
                transform: translate(-50%, -50%);
            }

            &.zone-0 {
                .msg {
                    transform: translate(5%, 0%);
                }
            }

            &.zone-14 {
                .msg {
                    transform: translate(-90%, 100%);
                }
            }

            &.zone-15 {
                .msg {
                    transform: translate(-90%, 100%);
                }
            }
        }
    }

    .mobile {
        position: relative;

        .msg {
            position: absolute;
            background-color: rgb(255, 0, 0);
            color: #fff;
            border-radius: 15px;
            overflow: hidden;
            width: 300px;
            padding: 1rem;
            box-sizing: border-box;
            font-size: 1rem;
            width: 96%;
            height: 14%;
            top: 10%;
            left: 2%;
            right: 2%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .zone {
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: center;

            //border: 1px solid red;

            .led {
                position: absolute;

                &.led-0 {
                    top: 68%;
                    left: 68%;
                }

                &.led-1 {
                    top: 25%;
                    left: 61%;
                    animation-delay: 0.1s;
                }

                &.led-2 {
                    top: 20%;
                    left: 61%;
                    animation-delay: 0.2s;
                }

                &.led-3 {
                    top: 52%;
                    left: 63%;
                    animation-delay: 0.3s;
                }

                &.led-4 {
                    top: 83%;
                    left: 28%;
                    animation-delay: 0.4s;
                }

                &.led-5 {
                    top: 70%;
                    left: 31%;
                    animation-delay: 0.5s;
                }

                &.led-6 {
                    top: 31%;
                    left: 17%;
                    animation-delay: 0.6s;
                }

                &.led-7 {
                    top: 43%;
                    left: 49.5%;
                    animation-delay: 0.7s;
                }

                &.led-8 {
                    top: 52%;
                    left: 45%;
                    animation-delay: 0.8s;
                }

                &.led-9 {
                    top: 72%;
                    left: 21%;
                    animation-delay: 0.9s;
                }

                &.led-10 {
                    top: 65%;
                    left: 63%;
                }

                &.led-11 {
                    top: 63%;
                    left: 42%;
                    animation-delay: 0.1s;
                }

                &.led-12 {
                    top: 34%;
                    left: 52%;
                    animation-delay: 0.2s;
                }

                &.led-13 {
                    top: 14%;
                    left: 19%;
                    animation-delay: 0.3s;
                }

                &.led-14 {
                    top: 37.2%;
                    left: 40.8%;
                    animation-delay: 0.4s;
                }

                &.led-15 {
                    top: 39.8%;
                    left: 40%;
                    animation-delay: 0.5s;
                }
            }
        }
    }
}

.our-offer {
    background-color: rgba(255, 0, 0, 0.9);
    color: #00003a;
    padding: 3rem 2rem;
    box-sizing: border-box;

    .main-title {
        font-family: "Oswald", sans-serif;
        text-transform: uppercase;
        font-size: 2.4rem;
        color: #fff;
        text-align: center;
        width: 100%;
        padding: 0 0 3rem;
        font-weight: 600;
        display: block;
    }

    > div {
        font-family: "Oswald", sans-serif;
        display: flex;
        flex-flow: row wrap;
        align-items: stretch;
        justify-content: space-between;
        max-width: 1400px;
        width: 100%;
        margin: auto;

        > div,
        > a {
            color: #00003a;
            text-decoration: none;
            padding: 1rem;
            box-sizing: border-box;
            overflow: hidden;
            border-radius: 15px;
            background: #fff;
            box-shadow: 0px 0px 34px 10px rgba(0, 0, 0, 0.3);
            transition: all 0.3s;
            flex: 0 0 31%;
            cursor: pointer;
            transition: all 0.3s;
            margin-bottom: 3rem;

            &:hover,
            &:focus {
                transform: scale(1.05);
                z-index: 1;
            }

            > div {
                display: flex;
                flex-flow: column;
                height: 100%;
            }
        }
    }
}

.title {
    text-transform: uppercase;
    font-weight: 900;
    font-size: 1.3rem;
    display: flex;
    align-items: center;
    padding: 0 0 1rem;
    box-sizing: border-box;
    font-family: Oswald, sans-serif;
}

.desc {
    font-family: "Roboto", sans-serif;
    font-weight: 300;
    font-size: 1.2rem;
    display: flex;
    align-items: flex-start;
    padding: 0;
    box-sizing: border-box;
    height: 84px;
    flex: 1;
    color: #000;
}

.media {
    width: 100%;
    aspect-ratio: 16/9;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 1rem 0 0;

    img {
        width: 100%;
        height: auto;
        border-radius: 15px;
    }
}

.btn {
    background-color: #00003a;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.6rem 1rem;
    font-size: 1.4rem;
    border-radius: 15px;
    margin-top: 1rem;
}

.led-yellow {
    margin: 0 auto;
    width: 6px;
    height: 6px;
    background-color: #ff0;
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 2px 1px, inset #808002 0 -1px 3px, #ff0 0 2px 12px;
    animation: blinkYellow 1s infinite;
}

.led-red {
    margin: 0 auto;
    width: 6px;
    height: 6px;
    background-color: #f00;
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 2px 1px, inset #441313 0 -1px 3px, rgba(255, 0, 0, 0.5) 0 2px 12px;
    animation: blinkRed 1s infinite;
}

.led-blue {
    margin: 0 auto;
    width: 6px;
    height: 6px;
    background-color: #24e0ff;
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 2px 1px, inset #006 0 -1px 3px, #3f8cff 0 2px 14px;
    animation: blinkBlue 1s infinite;
}

@keyframes blinkYellow {
    from {
        background-color: #ff0;
    }
    50% {
        background-color: rgb(110, 110, 0);
        box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 2px 1px, inset #808002 0 -1px 3px, #ff0 0 2px 12px;
    }
    to {
        background-color: #ff0;
    }
}

@keyframes blinkRed {
    from {
        background-color: rgb(253, 74, 74);
    }
    50% {
        background-color: rgb(124, 0, 0);
        box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 2px 1px, inset #441313 0 -1px 3px, rgba(255, 0, 0, 0.5) 0 2px 0;
    }
    to {
        background-color: rgb(253, 74, 74);
    }
}

@keyframes blinkBlue {
    from {
        background-color: #24e0ff;
    }
    50% {
        background-color: #205099;
        box-shadow: rgba(0, 0, 0, 0.2) 0 -1px 2px 1px, inset #006 0 -1px 3px, #3f8cff 0 2px 14px;
    }
    to {
        background-color: #24e0ff;
    }
}

// Transition infobulle
.v-enter-active,
.v-leave-active {
    transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}

@media (max-width: 1400px) {
}
@media (max-width: 1200px) {
    .intro {
        margin: 3rem 0;
    }

    .our-offer > div > div,
    .our-offer > div > a {
        flex: 0 0 48%;
    }
}

@media (max-width: 992px) {
}

@media (max-width: 768px) {
    .our-offer {
        padding: 2rem 1rem;

        .main-title {
            font-size: 2rem;
            padding: 0 0 2rem;
        }
    }

    .our-offer > div > div,
    .our-offer > div > a {
        flex: 0 0 100%;
        margin-bottom: 1rem;

        &:hover,
        &:focus {
            transform: none;
        }
    }
}

@media (max-width: 576px) {
    .intro {
        margin: 1rem 0;
    }

    .our-offer {
        padding: 1.6rem 1rem;

        .main-title {
            font-size: 1.6rem;
            padding: 0 0 1.6rem;
        }
    }

    .title {
        font-size: 1.2rem;
    }

    .desc {
        font-size: 1rem;
    }

    .btn {
        font-size: 1.2rem;
    }
}
</style>
